
import { useState } from "react";
import { Outlet } from "react-router-dom";
import { DigitalIdSidebar } from "@/components/dashboard/DigitalIdSidebar";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { MobileDashboardHeader } from "@/components/mobile/MobileDashboardHeader";
import { RouteTransition } from "@/components/dashboard/RouteTransition";
import { AIConciergeButton } from "@/components/ai/AIConciergeButton";
import { EnhancedMobileBottomNav } from "@/components/mobile/EnhancedMobileBottomNav";
import { PullToRefresh } from "@/components/ui/pull-to-refresh";
import { usePWAFeatures } from "@/hooks/usePWAFeatures";

export const DashboardLayout = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const { isOnline } = usePWAFeatures();

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleRefresh = async () => {
    // Implement refresh logic here
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-background text-foreground relative">
      {/* Enhanced background with brand-appropriate gradients */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-br from-background via-background to-card" />
        <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-gradient-to-bl from-primary/5 to-transparent rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-secondary/5 to-transparent rounded-full blur-3xl" />
      </div>

      {/* AI Concierge - Available globally */}
      <AIConciergeButton />
      
      {/* Mobile Header */}
      <MobileDashboardHeader />
      
      {/* Desktop Layout */}
      <div className="hidden md:flex h-screen">
        <DigitalIdSidebar isCollapsed={isCollapsed} onCollapse={handleToggleCollapse} />
        <div className="flex-1 flex flex-col overflow-hidden">
          <DashboardHeader />
          <main className="flex-1 overflow-y-auto p-6">
            <RouteTransition>
              <Outlet />
            </RouteTransition>
          </main>
        </div>
      </div>
      
      {/* Mobile Layout */}
      <div className="md:hidden pt-16">
        <main className="min-h-screen p-4 pb-20">
          {/* Offline indicator */}
          {!isOnline && (
            <div className="bg-destructive text-destructive-foreground px-4 py-2 text-center text-sm font-medium rounded-lg mb-4">
              You're offline. Some features may be limited.
            </div>
          )}
          
          <PullToRefresh onRefresh={handleRefresh}>
            <RouteTransition>
              <Outlet />
            </RouteTransition>
          </PullToRefresh>
        </main>
        
        <EnhancedMobileBottomNav />
      </div>
    </div>
  );
};
